import { typography, colors, Select } from '@insurancemenu/imenu-components-lib';
import TableInfoBar from 'components/common/download-files/TableInfoBar';
import styled from 'styled-components';

export const DateStyled = styled.p`
  ${typography.bold[16]};
  color: ${colors.green[600]};
  margin: 0;
  text-align: right;
`;

export const SelectStyled = styled(Select)`
  margin: 0 auto 8rem;
`;

export const TableInfoBarStyled = styled(TableInfoBar)`
  margin-bottom: 0;
`;

export const ZipTitleSectionStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  justify-content: space-between;
`;
